import { createContext, useContext, useCallback } from "react";
import { translations, deptNames } from "../i18n";

export const LangContext = createContext("en");

export const useLang = () => useContext(LangContext);

export const useT = () => {
  const lang = useLang();
  return useCallback((key) => translations[lang]?.[key] || translations.en?.[key] || key, [lang]);
};

export const useDeptName = () => {
  const lang = useLang();
  return useCallback((key) => deptNames[lang]?.[key] || deptNames.en?.[key] || key, [lang]);
};
